import { Formik, Form } from "formik";
import * as Yup from "yup";
import InputFormik from "../../../../common/components/form/InputFormik";
import ButtonWithLoader from "../../../../common/components/ui/loading/ButtonLoading";
import { maskPhone } from "../../../../common/helpers/mask.helpers";

// Esquema de validação com Yup
const validationSchema = Yup.object().shape({
  name: Yup.string()
    .required("Nome é obrigatório")
    .test(
      "full-name",
      "Deve incluir pelo menos um nome e um sobrenome",
      (value) => {
        if (!value) return false;
        const parts = value.split(" ");
        return parts.length >= 2;
      }
    ),
});

type FormPropsCreateLead = {
  onSubmit: (values: { name: string }) => void;
};

function FormCreateLead(props: FormPropsCreateLead) {
  const initialValues = {
    name: "",
    groupName: JSON.parse(localStorage.selectedCompanies)[0]?.city,
  };

  const handleSubmit = async (values, { setSubmitting }) => {
    setSubmitting(true);
    await props.onSubmit(values);
    setSubmitting(false);
  };

  return (
    <Formik
      initialValues={initialValues}
      validationSchema={validationSchema}
      onSubmit={handleSubmit}
    >
      {({ isSubmitting, handleSubmit }) => {
        return (
          <Form>
            <InputFormik
              label="Nome completo:"
              name="name"
              className="w-full mb-3"
              required={true}
            />
            <InputFormik
              label="WhatsApp:"
              name="whatsapp"
              type="whatsapp"
              required={true}
              mask={maskPhone}
            />

            {/* Botão de Envio */}
            <div className="flex justify-end">
              <ButtonWithLoader isLoading={isSubmitting} onClick={handleSubmit}>
                Enviar
              </ButtonWithLoader>
            </div>
          </Form>
        );
      }}
    </Formik>
  );
}

export default FormCreateLead;
